export enum StatusCard {
  FREE = 'Free',
  RECOMENDATE = 'Basic',
  PRO = 'PRO',
}
